import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => (
  <div style={{ textAlign: 'center', padding: '4rem' }}>
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist or the outlook is invalid.</p>
    <Link to="/" style={{ color: '#1976d2', textDecoration: 'underline', fontSize: '1.2rem' }}>
      Go Home
    </Link>
  </div>
);

export default NotFoundPage;
